import { createContext } from "react";

export const AssistantInteractionContext = createContext(false);
